import { FC } from 'react';

interface ProgressRowProps {
    label: string;
    value: number;
    total: number;
    color: string;
}

export const InternalProgressRow: FC<ProgressRowProps> = ({ label, value, total, color }) => {
    const pct = total > 0 ? (value / total) * 100 : 0;
    return (
        <div>
            <div className="flex items-center justify-between text-[11px] mb-1">
                <span className="text-neutral-600">{label}</span>
                <span className="font-medium text-neutral-900">{value}</span>
            </div>
            <div className="h-1 bg-neutral-100 overflow-hidden">
                <div className={`h-full ${color}`} style={{ width: `${pct}%` }} />
            </div>
        </div>
    );
};
